import { Icon } from '@/components/Icon';
import { useActivityPreview } from '@/hooks';

type Props = {
  activityId: string;
};

export const PreviewActivity: React.FC<Props> = ({ activityId }) => {
  const { setActivityId } = useActivityPreview();

  const handlePreviewActivity = () => setActivityId(activityId);

  return <Icon i="View" onClick={handlePreviewActivity} />;
};
